import { render, staticRenderFns } from "./Candidancy.vue?vue&type=template&id=7d6926ca"
import script from "./Candidancy.vue?vue&type=script&lang=js"
export * from "./Candidancy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports